
export const getMetricFilterMetric = (metric) => `${metric}::metric`;
export const getMetricFilterPctMetric = (metric) => `${metric}::metricPct`;

export const addMetricFilterTag = (row = {}) => {
  const taggedRow = {};
  for (const [key, value] of Object.entries(row)) {
    taggedRow[getMetricFilterMetric(key)] = value;
  }
  return taggedRow;
};
